import { Platform } from 'react-native';

// TODO: Replace with your actual Stripe publishable key
// Get it at: https://dashboard.stripe.com/apikeys
// Use the publishable key (pk_live_... or pk_test_...) — never the secret key
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_HRbFcYv1q13ZZvAuNtt57sgn';

// TODO: Replace with your actual Stripe product/price IDs
// Create these at: https://dashboard.stripe.com/products
export const STRIPE_PRODUCTS = {
  pro_monthly: {
    priceId: 'price_1TD9yoBzC11BasKIuD4yMHff', // replace after creating in Stripe dashboard
    name: 'Slate Pro — Monthly',
    price: 2900, // cents
    interval: 'month',
  },
  pro_annual: {
    priceId: 'price_1TDA01BzC11BasKIZN0u8WL0', // replace after creating in Stripe dashboard
    name: 'Slate Pro — Annual',
    price: 19900, // cents
    interval: 'year',
  },
};

export const PRO_FEATURES = [
  'Unlimited invoicing',
  'Unlimited clients',
  'Unlimited AI quote generation',
  'Room Scanner (AI material lists)',
  'Job Board & Drive Log',
  'Multiple businesses',
];

export const FREE_LIMITS = {
  clients: 5,
  aiGenerationsPerMonth: 3,
};

export async function setupStripe() {
  if (Platform.OS === 'web') return;
  try {
    const { initStripe } = await import('@stripe/stripe-react-native');
    await initStripe({
      publishableKey: STRIPE_PUBLISHABLE_KEY,
      merchantIdentifier: 'merchant.com.slate.quotes',
      urlScheme: 'slate-quotes',
    });
  } catch (error) {
    console.warn('Stripe initialization failed:', error.message);
  }
}
